import { EventType } from '../EventType';
import { ApplicationEvent } from '../GameEvent';
export class RefreshRegisteredStreamersEvent extends ApplicationEvent {
    constructor() {
        super(...arguments);
        this.eventType = EventType.REFRESH_REGISTERED_STREAMERS;
    }
}
